import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NamedLink from '../NamedLink/NamedLink';

import css from './TabNav.module.css';

const Tab = props => {
  const {
    className = null,
    id,
    disabled = false,
    text,
    selected = false,
    linkProps,
    linkClassName,
    selectedClassName,
    disabledClassName,
  } = props;
  const linkClasses = classNames(linkClassName || css.link, {
    [selectedClassName || css.selectedLink]: selected,
    [disabledClassName || css.disabled]: disabled,
  });

  return (
    <div id={id} className={className}>
      <NamedLink className={linkClasses} {...linkProps}>
        {text}
      </NamedLink>
    </div>
  );
};

const { string, node, bool, object, arrayOf } = PropTypes;

Tab.propTypes = {
  id: string.isRequired,
  className: string,
  text: node.isRequired,
  disabled: bool,
  selected: bool,
  linkProps: object.isRequired,
  linkClassName: string,
  selectedClassName: string,
  disabledClassName: string,
};

const TabNav = props => {
  const {
      className = null,
      rootClassName = null,
      tabRootClassName = null,
      tabs,
      linkClassName,
      selectedClassName,
      disabledClassName,
  } = props;
  const classes = classNames(rootClassName || css.root, className);
  const tabClasses = tabRootClassName || css.tab;
  return (
    <nav className={classes}>
      {tabs.map((tab, index) => {
        const id = typeof tab.id === 'string' ? tab.id : `${index}`;
        return (
          <Tab
            key={id}
            id={id}
            className={tabClasses}
            linkClassName={linkClassName}
            selectedClassName={selectedClassName}
            disabledClassName={disabledClassName}
            {...tab}
          />
        );
      })}
    </nav>
  );
};

TabNav.propTypes = {
  className: string,
  rootClassName: string,
  tabRootClassName: string,
  tabs: arrayOf(object).isRequired,
  linkClassName: string,
  selectedClassName: string,
  disabledClassName: string,
};

export default TabNav;
